{
  "errors.unknown": "An unknown error occurred.",
  "errors.battle.moveFailed": "That move didn't go through. Try again.",
  "errors.network": "Couldn't reach the server. Check your connection and try again.",
  "errors.battle.confirmHandFailed": "Couldn't lock in your hand. Try again.",
  "errors.battle.startCampaignFailed": "Couldn't start this campaign battle. Try again.",
  "errors.battle.startSquadFailed": "Couldn't start the squad battle. Try again.",
  "errors.battle.matchFailed": "Couldn't find a match. Try again.",
  "errors.session.signInAgain": "Please sign in again to continue.",
  "errors.battle.leaderboardFailed": "Couldn't load the ladder. Try again.",
  "errors.battle.startFailed": "Couldn't start the battle. Try again.",
  "errors.pets.loadFailed": "Couldn't load your Suikamon. Try again.",
  "errors.pets.moveToPlayFailed": "Couldn't move this Suikamon into the game. Try again.",
  "errors.pets.donateEggFailed": "Couldn't donate the egg. Try again.",
  "errors.pets.sellFailed": "Couldn't sell this Suikamon. Try again.",
  "errors.battle.freshBattleFailed": "Couldn't start a fresh battle. Please try again.",
  "errors.campaign.giftFailed": "Couldn't open the gift — try again.",
  "errors.boundary.title": "Something went wrong",
  "errors.boundary.text": "The app hit an unexpected error and our team has been notified. Reloading usually fixes it.",
  "errors.boundary.reload": "Reload",
  "errors.boundary.copied": "✓ Copied!",
  "errors.boundary.copy": "Copy error details",
  "errors.boundary.copyPrompt": "Copy the error details below:"
}
